import EditIcon from "assets/icon/EditIcon"

export const GridEditButton = ({ onClick, size = 'w-4', isActive = true }) => {
    return (
        <button className={`p-2 bg-black rounded-lg gap-2 ${isActive ? 'flex' : 'hidden'}`} onClick={onClick}>
            <EditIcon className={`fill-white ${size}`} />
        </button>
    )
}